module.exports = __webpack_public_path__ + "img/bg_icon1.64ffd8fc.png";